import React from 'react';
import UserContext from "../userContext";
import { useHistory } from "react-router-dom";

import Loader from "../Layout/Components/Loader";
import '../styles/main.scss';

export default function Login() {
    const [email, setEmail] = React.useState('');
    const [password, setPassword] = React.useState('');
    const [remember, setRemember] = React.useState(false);
    const [loading, setLoading] = React.useState(false);
    const [error, setError] = React.useState('');

    const userContext = React.useContext(UserContext);
    const history = useHistory();

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError('');
        setLoading(true);
        
        try {
            const result = await userContext.apiReducer('login', {
                email: email,
                password: password
            }, { remember: remember });
            
            setLoading(false);
            
            if (result?.generatePassword) {
                history.push('/generate');
            } else {
                history.push('/');
            }
        } catch (err) {
            setLoading(false);
            setError('Email ou mot de passe incorrect');
            console.error(err);
        }
    };

    return (
        <div className="auth-page">
            {/* Animated Background */}
            <div className="auth-background">
                <div className="auth-orb auth-orb--1" />
                <div className="auth-orb auth-orb--2" />
                <div className="auth-orb auth-orb--3" />
            </div>

            {/* Auth Card */}
            <div className="auth-card">
                {/* Logo */}
                <div className="auth-logo">
                    <img 
                        src="https://i.ibb.co/3CgD7G4/new-Colors-Logo-2.webp" 
                        alt="MYPacôme Logo" 
                    />
                    <h1 className="auth-brand">MYPacôme</h1>
                    <p className="auth-tagline">Home Manager</p>
                </div>

                {/* Title */}
                <div className="auth-title">
                    <h2>Connexion</h2>
                    <p>Accédez à votre espace propriétaire</p>
                </div>

                {/* Error Message */}
                {error && (
                    <div className="auth-message error">
                        {error}
                    </div>
                )}

                {/* Form */}
                <form className="auth-form" onSubmit={handleSubmit}>
                    <div className="form-group">
                        <label className="form-label" htmlFor="email">
                            Adresse email
                        </label>
                        <input
                            type="email"
                            id="email"
                            className="form-input"
                            placeholder="votre@email.com"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            required
                            autoComplete="email"
                        />
                    </div>

                    <div className="form-group">
                        <label className="form-label" htmlFor="password">
                            Mot de passe
                        </label>
                        <input
                            type="password"
                            id="password"
                            className="form-input"
                            placeholder="••••••••"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            required
                            autoComplete="current-password"
                        />
                    </div>

                    <div className="auth-checkbox">
                        <input
                            type="checkbox"
                            id="remember"
                            checked={remember}
                            onChange={(e) => setRemember(e.target.checked)}
                        />
                        <label htmlFor="remember">
                            Se souvenir de moi
                        </label>
                    </div>

                    <button type="submit" className="auth-btn">
                        Se connecter
                    </button>
                </form>

                {/* Footer */}
                <div className="auth-footer">
                    <p>
                        <button 
                            type="button"
                            className="auth-btn-secondary"
                            onClick={() => history.push('/reset')}
                        >
                            Mot de passe oublié ?
                        </button>
                    </p>
                </div>
            </div>

            <Loader show={loading} message="Connexion en cours..." />
        </div>
    );
}
